var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-map',{staticClass:"widget-static-map",attrs:{"center":_vm.center,"zoom":_vm.zoom,"options":_vm.mapOptions},on:{"ready":_vm.onMapReady}},[_c('l-tile-layer',{attrs:{"url":"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"}}),_c('l-marker',{attrs:{"lat-lng":_vm.center,"icon":_vm.markerIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }